import TextAreaBox from './src/TextAreaBox'

TextAreaBox.install = function (Vue) {
    Vue.component(TextAreaBox.name, TextAreaBox);
};

export default TextAreaBox;